export default __webpack_public_path__ + "static/Quote_Image_Mobile-cb1770adc03a30f090e1b644c78fb013.jpg";